document.addEventListener('DOMContentLoaded', function () {
  var els = document.querySelectorAll('[data-announcement-convert="true"]');
  if (!els.length) return;
  if (!window.Shopify || !Shopify.currency || !Shopify.currency.rate) return;

  var rate = parseFloat(Shopify.currency.rate);
  if (!rate || isNaN(rate) || rate === 1) return;

  var currencyCode = Shopify.currency.active;

  els.forEach(function (el) {
    var original = el.getAttribute('data-announcement-original');
    if (!original) return;

    var match = original.match(/\$([0-9]+(?:\.[0-9]+)?)/);
    if (!match) return;

    var usdAmount = parseFloat(match[1]);
    var converted = Math.ceil(usdAmount * rate);

    var formatted;
    try {
      formatted = new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(converted);
    } catch (e) {
      return;
    }

    el.textContent = original.replace(match[0], formatted);
  });
});
